"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GeneralSettings;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../../prop-types");

var _editor = require("../../../components/visualizations/editor");

var _utils = require("./utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function GeneralSettings(_ref) {
  var options = _ref.options,
      data = _ref.data,
      onOptionsChange = _ref.onOptionsChange;
  var countryCodeTypes = (0, _react.useMemo)(() => {
    switch (options.mapType) {
      case "countries":
        return {
          name: "Short name",
          name_long: "Full name",
          abbrev: "Abbreviated name",
          iso_a2: "ISO code (2 letters)",
          iso_a3: "ISO code (3 letters)",
          iso_n3: "ISO code (3 digits)"
        };

      case "subdiv_japan":
        return {
          name: "Name",
          name_local: "Name (local)",
          iso_3166_2: "ISO-3166-2"
        };

      default:
        return {};
    }
  }, [options.mapType]);

  var handleChangeAndInferType = newOptions => {
    newOptions.countryCodeType = (0, _utils.inferCountryCodeType)(newOptions.mapType || options.mapType, data ? data.rows : [], newOptions.countryCodeColumn || options.countryCodeColumn) || options.countryCodeType;
    onOptionsChange(newOptions);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
    label: "Map type",
    "data-test": "Choropleth.Editor.MapType",
    defaultValue: options.mapType,
    onChange: mapType => handleChangeAndInferType({
      mapType
    })
  }, /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
    key: "countries",
    "data-test": "Choropleth.Editor.MapType.Countries"
  }, "Countries"), /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
    key: "subdiv_japan",
    "data-test": "Choropleth.Editor.MapType.Japan"
  }, "Japan/Prefectures"))), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
    label: "Key column",
    "data-test": "Choropleth.Editor.KeyColumn",
    defaultValue: options.countryCodeColumn,
    onChange: countryCodeColumn => handleChangeAndInferType({
      countryCodeColumn
    })
  }, (0, _lodash.map)(data.columns, (_ref2) => {
    var name = _ref2.name;
    return /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
      key: name,
      "data-test": "Choropleth.Editor.KeyColumn.".concat(name)
    }, name);
  }))), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
    label: "Key type",
    "data-test": "Choropleth.Editor.KeyType",
    value: options.countryCodeType,
    onChange: countryCodeType => onOptionsChange({
      countryCodeType
    })
  }, (0, _lodash.map)(countryCodeTypes, (name, type) => /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
    key: type,
    "data-test": "Choropleth.Editor.KeyType.".concat(type)
  }, name)))), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
    label: "Value column",
    "data-test": "Choropleth.Editor.ValueColumn",
    defaultValue: options.valueColumn,
    onChange: valueColumn => onOptionsChange({
      valueColumn
    })
  }, (0, _lodash.map)(data.columns, (_ref3) => {
    var name = _ref3.name;
    return /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
      key: name,
      "data-test": "Choropleth.Editor.ValueColumn.".concat(name)
    }, name);
  }))));
}

GeneralSettings.propTypes = _propTypes.EditorPropTypes;
//# sourceMappingURL=GeneralSettings.js.map